import service from '../service.js'

export default {
    /**
     * 添加车间信息
     * @param {*} workshopName 
     * @param {*} factoryId 
     * @returns 
     */
    AddWorkshops: (workshopName, factoryId) => {
        return service({
            url: '/Workshops/AddWorkshops',
            method: 'post',
            params: { workshopName, factoryId }
        })
    },
    /**
     * 根据厂区id获取车间信息
     * @param {*} factoryId 
     * @returns 
     */
    GetWorkshops: (factoryId) => {
        return service({
            url: '/Workshops/GetWorkshops',
            method: 'get',
            params: { factoryId }
        })
    },
    /**
     * 删除车间信息
     * @param {*} workshopId 
     * @returns 
     */
    DeleteWorkshops: (workshopId) => {
        return service({
            url: '/Workshops/DeleteWorkshops',
            method: 'post',
            params: { workshopId }
        })
    },
}